export const modifyUser = obj => {
  return {
    type: "UPDATE_USER",
    payload: obj
  }
}
